module.exports = __webpack_public_path__ + "img/phone.baf752b2.png";